import React from 'react'

const Pagination = ({ currentPage, setCurrentPage, noOfRows, limit = 50, setClicked }: {
    currentPage: number,
    setCurrentPage: any,
    noOfRows:number
    limit?: number
    setClicked?: (value:boolean) => void
}) => {
  const handlePreviousPage = () => {
    setCurrentPage((prevPage: number) => prevPage - 1)
    setClicked && setClicked(true)
  }

  const handleNextPage = () => {
    setCurrentPage((prevPage: number) => prevPage + 1)
    setClicked && setClicked(true)
  }

  return (
      <>
        {currentPage > 0 && <button onClick={handlePreviousPage}>Previous</button>}
        {(noOfRows === limit) && <button onClick={handleNextPage}>Next</button>}
      </>
  )
}

export default Pagination
